import type { CSSProperties } from 'react';
import styled from 'styled-components';

const SMALL_BUTTON_SIZE = '1rem';
const SMALL_ICON_SIZE = '0.75rem';

export const labelContainerStyle: CSSProperties = {
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center'
};

export const dealerDiscountContainerStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '17px',
    marginBottom: '0.6rem'
};

export const deferredDownPaymentContainerStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    minHeight: '1.1875rem',
    marginBottom: '0.25rem'
};

export const labelStyle: CSSProperties = {
    color: '#005BA8',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer'
};

export const labelTextStyle: CSSProperties = {
    marginRight: '0.25rem',
    color: '#6D6D6D'
};

export const MessagesContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
`;

export const InlineGroupContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 1rem;
    flex-wrap: wrap;

    @media (max-width: 768px) {
        flex-direction: column;

        & > * {
            width: 100%;
            flex: 1 1 100%;
        }
    }

    @media (min-width: 769px) {
        & > * {
            flex: 1 1 0;
            min-width: 0;
        }
    }
`;

export const InputWrapper = styled.div`
    width: 100%;
`;

// overriding interstate's default to match UI mockup
export const smallCloseButtonSx = {
    '& button[aria-label="Close"]': {
        width: `${SMALL_BUTTON_SIZE} !important`,
        height: `${SMALL_BUTTON_SIZE} !important`,
        minWidth: `${SMALL_BUTTON_SIZE} !important`,
        minHeight: `${SMALL_BUTTON_SIZE} !important`,
        padding: '0 !important',
        '& svg': {
            width: `${SMALL_ICON_SIZE} !important`,
            height: `${SMALL_ICON_SIZE} !important`
        }
    }
};

export const editLabelStyle: CSSProperties = {
    marginLeft: 2,
    color: '#005BA8',
    fontSize: '0.75rem'
};

export const amountDueAtSigningContainerStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '1rem'
};

export const amountDueAtSigningPaidByContainerStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '1rem'
};

export const targetCashAmountPaidCheckboxStyle: CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem'
};

export const summaryDueAtSigningSlideOutContainerStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'left',
    gap: '1rem'
};

export const cashAmountPaidNumericInputStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    flex: 1,
    minWidth: 0 // Prevents flex item from overflowing
};

export const equityAllocationMethodInputStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    flex: 1,
    minWidth: 0 // Prevents flex item from overflowing
};

export const inlineGroupContainerStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start', // Changed from 'center' to 'flex-start' for proper top alignment
    gap: '1rem',
    flexWrap: 'wrap' // Allows items to wrap on smaller screens
};

export const labelWithTooltipStyle: CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem'
};
